import { useEffect, useRef } from 'react';

import { useFlags } from '../../hooks/use-flags';

/**
 * Initializes Datadog RUM and Logs if the feature flag is enabled
 */
export const DatadogInitializer = () => {
    const { enableDatadogMyphx } = useFlags();
    const isInitialized = useRef(false);

    useEffect(() => {
        if (!enableDatadogMyphx || isInitialized.current) {
            return;
        }

        const initialize = async () => {
            if (isInitialized.current) return;

            try {
                const { initializeDatadog } = await import('../../datadog');
                await initializeDatadog();
                isInitialized.current = true;
            } catch (error) {
                // oxlint-disable-next-line no-console
                console.error('Error initializing Datadog:', error);
            }
        };

        initialize();
    }, [enableDatadogMyphx]);

    return null;
};
